/** @format */

import styled, { keyframes } from 'styled-components';

export const bounceAnimation = keyframes`
  from {
    transform: scale(0);
  }
  to {
    transform: scale(2.5);
  }
`;

export const LoaderWrapper = styled.div`
  position: absolute;
  top: 15px;
  left: 50%;
  transform: translateX(-50%);
  height: 30px;
  width: 60px;
  display: flex;
  justify-content: center;
  border-radius: 6px;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.joivy.white};

  @media screen and (max-width: 1160px) {
    top: calc(2.5rem + 20px);
  }
`;

export const Dot = styled.div<{ $delay: number }>`
  width: 4px;
  height: 4px;
  margin: 0 4px;
  background-color: ${({ theme }) => theme.colors.joivy['teal-dark']};
  border-radius: 50%;
  animation: ${bounceAnimation} 0.5s infinite alternate;
  animation-delay: ${({ $delay }) => $delay}s;
`;
